/**
* Handles the google map complete search requests
*/
function initAutocomplete() {

	clearSearch();

  	var oSearchOptions = {
	  //types: ['(cities)'],	//	Comment out to allow all search areas not just cities
	  //componentRestrictions: {country: "GB"}
	};

	//	After every keystroke clear the form
	$( '#search-box' ).keyup( function( event ) { 

		clearSearch();
		var geocoder = new google.maps.Geocoder();
		var firstResult = $(".pac-container .pac-item:first").text();
		geocoder.geocode({"address":firstResult }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var iLat = results[0].geometry.location.lat(),
                    iLng = results[0].geometry.location.lng();
                	fillInFields(iLat,iLng);
            }
        });



	});





	//	Display the dropdown when typing in the address for the locations
	//	Populate lat and long when clicked
	var oAutocomplete = new google.maps.places.Autocomplete( ( document.getElementById( 'search-box' ) ), oSearchOptions );
	oAutocomplete.addListener( 'place_changed', autoPopulateFields );












    // Clear search
	function clearSearch() {
		document.getElementById( 'search-lat' ).value = '';
		document.getElementById( 'search-lat' ).disabled = false;
		document.getElementById( 'search-lng' ).value = '';
		document.getElementById( 'search-lng' ).disabled = false;
		$('nav.store-filter form').addClass('no-address-entered');
	}




    // Fill in address
	function autoPopulateFields() {
		var oPlace                = oAutocomplete.getPlace();
		if(typeof(oPlace.geometry) == 'undefined'){

		}else{
			var oLatLong              = oPlace.geometry.location;
			fillInFields(oLatLong.lat(),oLatLong.lng());

		}
	}




	function fillInFields(iLat,iLng){
		clearSearch();
    	document.getElementById( 'search-lat' ).value = iLat;
    	document.getElementById( 'search-lng' ).value = iLng;
    	$('nav.store-filter form').removeClass('no-address-entered');
	}

}
